/**
 * @generated SignedSource<<04a0fab4fbf1ddab319974a4858bfb80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime'
export type useDialogueAreaQuery$variables = {
  prefecture: string
}
export type useDialogueAreaQuery$data = {
  readonly listCitiesByPrefectureRoma: {
    readonly items: ReadonlyArray<{
      readonly cityId: number
      readonly name: string
      readonly kana: string
    }>
  }
}
export type useDialogueAreaQuery = {
  variables: useDialogueAreaQuery$variables
  response: useDialogueAreaQuery$data
}

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'prefecture'
      }
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Literal',
            name: 'limit',
            value: 300
          },
          {
            kind: 'Variable',
            name: 'prefectureRoma',
            variableName: 'prefecture'
          }
        ],
        concreteType: 'CityConnection',
        kind: 'LinkedField',
        name: 'listCitiesByPrefectureRoma',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'City',
            kind: 'LinkedField',
            name: 'items',
            plural: true,
            selections: [
              {
                alias: 'cityId',
                args: null,
                kind: 'ScalarField',
                name: 'id',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'name',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'kana',
                storageKey: null
              }
            ],
            storageKey: null
          }
        ],
        storageKey: null
      }
    ]
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'useDialogueAreaQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'useDialogueAreaQuery',
      selections: v1 /*: any*/
    },
    params: {
      cacheID: 'f107ee5323ff28c44377176aaeba12ba',
      id: null,
      metadata: {},
      name: 'useDialogueAreaQuery',
      operationKind: 'query',
      text: 'query useDialogueAreaQuery(\n  $prefecture: String!\n) {\n  listCitiesByPrefectureRoma(prefectureRoma: $prefecture, limit: 300) {\n    items {\n      cityId: id\n      name\n      kana\n    }\n  }\n}\n'
    }
  }
})()

;(node as any).hash = '02335c270364c56294a1f8d5221d8ccd'

export default node
